<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-row justify="center" align="center" class="text-center">
    <v-col xs="12" sm="10" md="8" lg="8" xl="7">
      <v-stepper v-model="stepnow" vertical class="br-10">
        <v-card flat class="text-center transparent pa-2">
          <span class="title primary--text text--darken-2"><strong>{{ $t('booking_form') }}</strong></span>
        </v-card>

        <v-stepper-step :complete="stepnow > 1" step="1" @click.native="stepnow = 1">
          {{ $t('search_booking') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-form lazy-validation ref="formBookingPeriod" @submit.prevent="onSearchSlot">
            <v-card class="br-10 text-center elevation-3">
              <v-row justify="center">
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-menu v-model="from_date_menu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="data.from_date" :label="$t('from_date')"
                        :rules="[rules.required, lessThan(data.to_date), rules.maxDateRange]" prepend-icon="fa-calendar-o"
                        readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="data.from_date" @input="from_date_menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-menu v-model="to_date_menu" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="data.to_date" :label="$t('to_date')"
                        :rules="[rules.required, moreThan(data.from_date), rules.maxDateRange]"
                        prepend-icon="fa-calendar-o" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="data.to_date" @input="to_date_menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select v-model="data.bookingType" prepend-icon="fa-list" :items="bookingTypes"
                    :label="$t('bookingType')"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <v-select v-model="data.event" :disabled="loading || data.bookingType.length === 0" clearable
                    :prepend-icon="data.bookingType === 'venue' ? 'fa-map-marker' : 'fa-cubes'"
                    :items="data.bookingType.length > 0 ? events[data.bookingType] : []" item-value="value"
                    :label="$t('event')"></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea name="description" :label="$t('describe_purpose')" shaped outlined rows="5"
                    row-height="25" v-model="data.description" :rules="[validateRequired('description')]"></v-textarea>
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn color="primary" large type="submit" :disabled="!canProceed">
                    {{ $t('search') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-step :complete="stepnow > 2" step="2" @click.native="stepnow > 1 ? stepnow = 2 : null">
          {{ $t('select_booking_facilities') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-form ref="formBookingFacility">
            <v-row justify="center" style="overflow-x: scroll;">
              <v-col cols="12" v-if="loading">
                <div class="d-inline-flex">
                  <v-skeleton-loader v-for="index in loaderQuantity" :key="index" class="ma-3" min-width="284"
                    max-height="700" boilerplate type="image, article, actions" />
                </div>
              </v-col>
              <v-col cols="12" v-if="!loading">
                <div class="text-left text-h6 pl-5" v-if="bookingItems.length > 1">
                  {{ $t("slide_right_to_view_more_options") }}
                </div>
                <div class="d-inline-flex">
                  <v-card :loading="loading" max-width="284" max-height="700" class="ma-3"
                    v-for="(item, index) in bookingItems" :key="item._id">
                    <template slot="progress">
                      <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
                    </template>

                    <v-card-title class="pa-0">
                      <v-row justify="center" class="pa-0 pt-5">
                        <v-col cols="12" class="pa-0">
                          {{ index + 1 }} / {{ bookingItems.length }}
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <v-img lazy-src="img/cards/no_image_available.jpg" height="250" contain :alt="item.name"
                      :src="getImgUrl(item)"></v-img>

                    <v-card-title style="min-height: 100px; word-break: break-word;">
                      {{ item.name }}
                    </v-card-title>

                    <v-card-text>
                      <v-row align="center" class="mx-0">
                        <v-rating :value="4.5" color="amber" dense half-increments readonly size="14"></v-rating>

                        <div class="grey--text ms-4">
                          4.5 (413)
                        </div>
                      </v-row>

                      <div class="my-4 text-subtitle-1 text-left">
                        {{ $t("location") }}
                      </div>

                      <div class="text-left" style="min-height: 100px; word-break: break-word;">
                        {{ item.building_number }}, LOT: {{ item.lot || "-" }}, BLOK: {{ item.block || "-" }}, FL: {{
                          item.floor || "-" }}, {{ item.location }}
                      </div>
                    </v-card-text>

                    <v-divider class="mx-4"></v-divider>

                    <v-card-actions>
                      <v-row justify="space-around">
                        <v-col cols="6">
                          <v-btn color="error" text @click="stepnow--; data.selected_booking_facility = null">
                            {{ $t('back') }}
                          </v-btn>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-right">
                            <v-btn color="primary" @click="onSelectFacility(item)">
                              {{ $t("select") }}
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-step :complete="stepnow > 3" step="3" @click.native="stepnow > 2 ? stepnow = 3 : null">
          {{ $t('select_booking_slot') }}
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-form ref="formBookingSlot" @submit.prevent="stepnow++">
            <v-card class="br-10 text-center elevation-3 pb-5">
              <v-row justify="center">
                <v-col cols="12" v-if="loading" style="height: 600px;">
                  <v-skeleton-loader v-for="index in loaderQuantity" :key="index" class="mb-6" boilerplate
                    type="list-item-avatar-three-line" />
                </v-col>
                <v-col cols="12" v-if="!loading">
                  <v-list flat subheader two-line>
                    <div class="text-h5">
                      {{ data.selected_booking_facility ? data.selected_booking_facility.name : '' }}
                    </div>
                    <v-list-item v-if="timeslots.length === 0">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("message_no_available_timeslot") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item-group v-if="timeslots.length > 0" v-model="data.selected_time_slot" multiple>
                      <v-list-item :value="timeslot" class="pa-0" v-for="(timeslot, i) in timeslots" :key="i">
                        <template v-slot:default="{ active }">
                          <v-list-item-avatar>
                            <v-checkbox :input-value="active"></v-checkbox>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title>
                              {{ timeslot.date }} <br />
                              {{ timeslot.startTime }} -
                              {{ timeslot.endTime }}
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-list-item-title class="font-weight-bold text-h6">
                              RM {{ timeslot.price | ringgit }}
                            </v-list-item-title>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div class="text-right mt-5">
                    <v-btn color="error" text @click="stepnow--; data.selected_time_slot = []">
                      {{ $t('back') }}
                    </v-btn>
                    <v-btn :disabled="!canProceed" color="primary" type="submit">
                      {{ $t('proceed') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-step :complete="stepnow > 4" step="4" @click.native="stepnow > 3 ? stepnow = 4 : null">
          {{ $t('supporting_documents') }}
        </v-stepper-step>
        <v-stepper-content step="4">
          <v-card class="br-10 text-center elevation-3">
            <v-row justify="center">
              <v-col cols="12">
                <v-file-input v-model="files" accept="image/*,.pdf" color="deep-purple accent-4" counter label="File input" multiple
                  placeholder="Select your files" prepend-icon="mdi-paperclip" :show-size="1000">
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
                      {{ text }}
                    </v-chip>

                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
                <div class="text-right mt-5">
                  <v-btn color="error" text @click="stepnow--; files = []; data.attachments = {};">
                    {{ $t('back') }}
                  </v-btn>
                  <v-btn :disabled="!canProceed" color="primary" @click="stepnow++;setFiles();">
                    {{ $t('proceed') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-step :complete="stepnow > 5" step="5" @click.native="stepnow > 4 ? stepnow = 5 : null">
          {{ $t('additional_request') }}
        </v-stepper-step>
        <v-stepper-content step="5">
          <v-card class="br-10 text-center elevation-3">
            <v-row justify="center">
              <v-col cols="12">
                <v-textarea clearable v-model="data.additional_request"
                  :placeholder="`${$t('additional_request')} (${$t('optional')})`" name="additional_request" required
                  type="textarea" :disabled="loading" :readonly="loading"></v-textarea>
                <div class="text-right mt-5">
                  <v-btn color="error" text @click="stepnow--; data.additional_request = ''">
                    {{ $t('back') }}
                  </v-btn>
                  <v-btn :disabled="!canProceed" color="primary" @click="stepnow++;">
                    {{ $t('proceed') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-step :complete="stepnow > 6" step="6" @click.native="stepnow > 5 ? stepnow = 6 : null">
          {{ $t('contact_detail') }}
        </v-stepper-step>
        <v-stepper-content step="6">
          <v-form ref="formContact" @submit.prevent="submitForm">
            <v-card class="br-10 text-center elevation-3">
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field prepend-icon="fa-user-circle fa-lg" clearable v-model="data.customer.name"
                    :label="$t('full_name')" name="full_name" required type="text" :disabled="loading" :readonly="loading"
                    :rules="[validateRequired('full_name')]"></v-text-field>
                  <v-text-field class="pt-2" prepend-icon="fa-id-card fa-lg" clearable name="ic_num"
                    :value="icFormat(data.customer.nric)" @input="data.customer.nric = $event" :counter="14"
                    maxLength="14" :label="$t('ic_num')" required type="text" :disabled="loading" :readonly="loading"
                    :rules="[validateRequired('ic_num'), rules.nricLength, rules.dateOfBirth]"></v-text-field>
                  <v-row wrap align="center" justify="center" class="text-center">
                    <v-col cols="12" sm="12" md="7" lg="7">
                      <v-text-field class="pt-2" maxLength="11" prepend-icon="fa-phone-square fa-lg"
                        :label="$t('phone_no')" v-model="data.customer.phone" name="phone_no" type="tel"
                        :disabled="verify.result || loading" :readonly="loading || verify.result" required
                        :rules="[validateRequired('phone_no')]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="5">
                      <v-btn color="primary" rounded outlined
                        :disabled="currentTime > 0 || data.customer.phone.length < 10" @click="sendVerification"
                        v-if="!verify.result">
                        {{ sent ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', {
                          channel: 'SMS'
                        }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row wrap align="center" justify="center" v-if="sent">
                    <v-col md="10" sm="12" cols="12">
                      <v-text-field prepend-icon="fa-code fa-lg" validate-on-blur :rules="[rules.required]"
                        v-model="verify.input" :label="$t('verification_code')" name="code" required type="text"
                        :disabled="verify.result"></v-text-field>
                    </v-col>
                    <v-col md="2" sm="12" cols="12">
                      <v-btn color="primary" rounded outlined :disabled="verify.input.length === 0 || verify.result"
                        @click="verifyCode">
                        {{ $t("verify") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-text-field class="pt-2" prepend-icon="fa-envelope fa-lg" v-model="data.customer.email"
                    :label="$t('email_address')" name="email_address" required type="email" :disabled="loading"
                    :readonly="loading" :rules="[validateRequired('email_address')]"></v-text-field>
                  <div class="text-right mt-5">
                    <v-btn color="error" text @click="stepnow--">{{ $t('back') }}</v-btn>
                    <v-btn color="primary" large type="submit" :loading="loading">
                      {{ $t('submit') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>
      </v-stepper>
      <br>
    </v-col>
    <v-col cols="12" v-if="data.selected_booking_facility">
      <v-footer app fixed elevation color="grey lighten-3" class="text-left">
        <v-row justify="space-between" class="d-inline-flex pr-10">
          <v-col cols="12" sm="8" class="text-subtitle-2">
            {{ data.selected_booking_facility.name }} <br />
            <span>
              {{ $t("total_duration") }}: {{ totalDuration }} ({{ $t("minute") }})
            </span>
          </v-col>
          <v-col cols="12" sm="4" class="fill-height"
            :class="{ 'text-right pr-10 py-0': !$vuetify.breakpoint.mobile, 'pa-0': !$vuetify.breakpoint.mobile }">
            <span class="text-subtitle-2 pr-5">
              {{ $t("total_amount_rm") }}:
            </span>
            <br />
            <span class="text-h5 font-weight-bold pr-5">
              {{ totalPrice | ringgit }}
            </span>
          </v-col>
        </v-row>
      </v-footer>
    </v-col>
  </v-row>
</template>

<script>
import axios from '../../axios'
import throttle from 'lodash/throttle'
import { mapActions } from 'vuex'
import configurations from '../../configurations'

function datediff (first, second) {
  // Take the difference between the dates and divide by milliseconds per day.
  // Round to nearest whole number to deal with DST.
  return Math.round((new Date(second) - new Date(first)) / (1000 * 60 * 60 * 24))
}

export default {
  computed: {
    canProceed () {
      if (this.stepnow === 1) {
        return this.data.from_date.length > 0 && this.data.to_date.length > 0 && this.data.bookingType && this.data.event && this.data.event.length > 0 && this.data.description.length > 8
      }
      if (this.stepnow === 3) {
        return this.data.selected_time_slot.length > 0
      }
      return true
    },
    isCordova () {
      return window.hasOwnProperty('cordova')
    },
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || this.$t('invalidDateOfBirth')) : true),
        required: value => !!value || this.$t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('invalidEmailFormat')
        },
        percentage: value => (Number(value) <= 100 && Number(value) >= 0) || this.$t('invalidPercentage'),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || this.$t('invalidNRICFormat')) : true),
        maxDateRange: value => {
          if (this.dateRangeWeek && this.dateRangeWeek.rental_item && this.dateRangeWeek.rental_item > 0) {
            const maxDays = this.dateRangeWeek.rental_item * 7
            return datediff(this.data.from_date, this.data.to_date) <= maxDays || this.$t('invalidDateRange')
          }
          return true
        }
      }
    },
    totalDuration () {
      return this.data.selected_time_slot.reduce((sum, timeslot) => sum + timeslot.duration, 0)
    },
    totalPrice () {
      return this.data.selected_time_slot.reduce((sum, timeslot) => sum + timeslot.price, 0)
    }
  },
  data: () => ({
    stepnow: 1,
    from_date_menu: false,
    to_date_menu: false,
    bookingTypes: [],
    bookingItems: [],
    timeslots: [],
    events: null,
    dateRangeWeek: null,
    data: {
      attachments: {},
      additional_request: '',
      channel: 'e-services',
      event: '',
      bookingType: '',
      selected_time_slot: [],
      selected_booking_facility: null,
      from_date: '',
      to_date: '',
      customer: {
        name: '',
        phone: '',
        email: '',
        nric: ''
      },
      type: 'booking'
    },
    files: [],
    loading: false,
    currentTime: 0,
    verify: {
      code: null,
      input: '',
      result: false
    },
    sent: false,
    timer: null,
    loaderQuantity: 5
  }),
  beforeMount: async function () {
    this.$store.commit('loading/setPageLoading', { loading: false })
    const user = await this.$store.dispatch('auth/session')
    if (user.userCtx.name && user.userCtx.name.length > 0 && !user.userCtx.roles.includes('_admin')) {
      this.verify.result = true
      this.data.customer = Object.assign({}, this.data.customer, { name: user.userCtx.full_name || '', phone: user.userCtx.phone || '', email: user.userCtx.name || '', nric: user.userCtx.ic_num || '' })
    }
    const { data: dateRangeWeek } = await axios({
      url: `${configurations.WORKER}/bookings/configurations`,
      method: 'GET'
    })
    this.dateRangeWeek = dateRangeWeek.dateRangeWeek
    const today = new Date()
    this.data.from_date = today.toISOString().slice(0, 10)
    this.data.to_date = today.toISOString().slice(0, 10)
    const { data: metadata } = await axios({
      url: `${configurations.WORKER}/query`,
      method: 'POST',
      data: { url: btoa(`/metadata/configuration`) }
    })
    this.bookingTypes = metadata.bookingTypes ? metadata.bookingTypes.map(row => ({ value: row, text: this.$t(row) })) : []
    if (!this.events) this.events = {}
    for (const eventType in metadata.events) {
      if (eventType === 'venue') {
        const { data: eventList } = await axios({
          url: `${configurations.WORKER}/bookings/activities`,
          method: 'GET'
        })

        this.events[eventType] = eventList.map(row => ({ value: row.code, text: row.name + ' / ' + row.en + ' / ' + row.zh }))
      }
    }

    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.data.geolocation = geolocation
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })
  },
  methods: {
    ...mapActions(['sendSMS']),

    getImgUrl (item) {
      return `${configurations.WORKER}/bookings/getAttachments/RENTEDITEM-${item._id}/profile_picture`
    },
    moreThan (payload) {
      return value => value >= payload || this.$t('invalidDateRange')
    },
    lessThan (payload) {
      return value => value <= payload || this.$t('invalidDateRange')
    },
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
      }
    },
    async setFiles () {
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })

      if (this.files.length > 0) {
        for (let file of this.files) {
          const base64Value = await toBase64(file)
          this.data.attachments[file.name] = {
            content_type: file.type,
            data: base64Value.split(',')[1]
          }
        }
      }
    },
    sendVerification: throttle(async function () {
      this.currentTime = 180
      this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(this.countdown, 1)
      this.sent = true
      await this.sendSMS({
        contact: this.data.customer.phone.replace(/\s/g, ''),
        message: `Your verification code is ${this.verify.code} for e-Booking application. Expires in 3 mins. Date: ${new Date().toLocaleString()}`
      })
    }, 1000),
    verifyCode () {
      if (this.verify.code === this.verify.input) {
        this.verify.result = true
        this.$store.dispatch('snackbar/setSnackBar', { color: 'success', message: this.$t('verify_successful'), visible: true })
        return
      }
      this.verify.result = false
      this.$store.dispatch('snackbar/setSnackBar', { color: 'error', message: this.$t('invalid_code'), visible: true })
    },
    startCamera: throttle(function (field) {
      const onSuccess = imageData => {
        this[field] = this.data._attachments[field] = {
          content_type: 'image/jpeg',
          data: imageData
        }
      }
      const onFail = message => {
        console.error(message) // eslint-disable-line
        this.$store.dispatch('snackbar/setSnackBar', { color: 'error', message, visible: true })
      }
      navigator.camera.getPicture(onSuccess, onFail, this.cameraOption)
    }, 1000),
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    validateRequired (translationKey) {
      const message = this.$t('validate_required', {
        field: this.$t(translationKey.toLowerCase())
      })
      return value => !!value || value === 0 || message
    },
    submitForm: throttle(async function ($event) {
      const result = this.$refs.formContact.validate()
      if (!result) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('incomplete_form'),
          visible: true
        })
        return
      }
      if (!this.verify.result) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('phone_is_not_verify'),
          visible: true
        })
        return
      }
      this.loading = true
      try {
        this.data.additional_request = this.data.additional_request.trim()
        this.data.customer.name = this.data.customer.name.trim().toUpperCase()
        this.data.customer.phone = this.data.customer.phone.replace(/\s/g, '')
        this.data.customer.email = this.data.customer.email.replace(/\s/g, '')
        this.data.customer.nric = this.data.customer.nric.replace(/\s/g, '')
        const response = await axios({
          url: `${configurations.WORKER}/bookings`,
          method: 'POST',
          data: this.data,
          headers: {
            'x-item': btoa(this.data.selected_booking_facility._id)
          }
        })
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: this.$t('submit_successful'),
          visible: true
        })
        this.$router.push(`/booking/detail/${response.data.id}?feedback=true`)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: error.message || error,
          visible: true
        })
      } finally {
        this.loading = false
      }
    }, 500),
    async onSearchSlot () {
      const valid = this.$refs.formBookingPeriod.validate()
      if (!valid) return

      if (this.bookingTypes.length > 0 && this.bookingTypes.filter(row => row.value === this.data.bookingType).length > 0) {
        this.loading = true
        axios({
          url: `${configurations.WORKER}/bookings/items`,
          method: 'GET',
          params: {
            startDate: this.data.from_date,
            endDate: this.data.to_date,
            code: this.data.event.toLowerCase().replace(/ /g, '_')
          }
        }).then(({ data }) => {
          this.bookingItems = data
          this.loading = false
        }).catch(error => {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: this.$t('attempt_failed_please_try_again') || error,
            visible: true
          })
          this.loading = false
        })
        this.stepnow++
      }
    },
    onSelectFacility (item) {
      this.data.selected_booking_facility = item
      this.loading = true
      axios({
        url: `${configurations.WORKER}/bookings/timetable`,
        method: 'GET',
        params: {
          startDate: this.data.from_date,
          endDate: this.data.to_date
        },
        headers: {
          'x-item': btoa(this.data.selected_booking_facility._id)
        }
      }).then(({ data }) => {
        this.timeslots = data
        this.loading = false
      }).catch(error => {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: this.$t('attempt_failed_please_try_again') || error,
          visible: true
        })
        this.loading = false
      })
      this.stepnow++
    }
  }
}
</script>
